import { render, staticRenderFns } from "./ReactivatePassword.vue?vue&type=template&id=cc29c764&scoped=true&"
import script from "./ReactivatePassword.vue?vue&type=script&lang=js&"
export * from "./ReactivatePassword.vue?vue&type=script&lang=js&"
import style0 from "./ReactivatePassword.vue?vue&type=style&index=0&id=cc29c764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc29c764",
  null
  
)

export default component.exports